import { template, view } from '@yola/ws-sdk';
import getOptionTargetElement from './get-option-target-element';

const createToggleOption = ({ item, blockNode, displayOptions, onClick }) => {
  const targetElement = getOptionTargetElement(item, blockNode);
  if (!targetElement) return null;

  const targetElementId = view.accessors.getLiveElementId(targetElement);
  const existedOption = displayOptions && displayOptions.find((option) => option.id === item.id);
  const isLiveAttributeEnabled = targetElement.hasAttribute(item.attribute);

  const isEnabled = item.inverted ? !isLiveAttributeEnabled : isLiveAttributeEnabled;
  const isInitialEnabled = existedOption ? existedOption.isInitialEnabled : isEnabled;
  const touched = existedOption?.touched;

  return {
    ...item,
    onClick,
    isInitialEnabled,
    isEnabled,
    elementId: targetElementId,
    label: template.accessors.getMetaTranslations(item.label),
    title: template.accessors.getMetaTranslations(item.title),
    subtitle: template.accessors.getMetaTranslations(item.subtitle),
    ...(touched && { touched }),
  };
};

export default createToggleOption;
